// extracted by mini-css-extract-plugin
module.exports = {"beauty_tools":"styles_beauty_tools__AOV8U","card":"styles_card__TvR0n","card__image":"styles_card__image__kU1_e","category_card__content":"styles_category_card__content__6OYsg"};